/* eslint-env browser, jquery */
import debugT from 'debug';
import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import 'slick-carousel';
import page from 'modules/ab-page-js';
import splash from './main.pug';
import metadata from './data/metadata.json';
import leadership from './data/leadership.json';
import joinUsPictures from './data/join-us-pictures.json';
import boardDirectors from './data/board-directors.json';
import quotes from './data/quotes.json';
import resources from './data/resources.json';

const debug = debugT('auth0:about');

export default function register() {
  page('/about', render, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init
      ? {}
      : { view: domify(splash({ leadership, joinUsPictures, boardDirectors, quotes, resources })) })
  };
  container.render(renderOptions);
  next();
}

function snippets(ctx, next) {
  $('body').addClass('loaded');

  $('.slick-join-us').slick({
    speed: 500,
    autoplay: false,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    slide: '.item',
    pauseOnHover: false
  });

  $('.quotes__slider').slick({
    autoplay: true,
    autoplaySpeed: 25000,
    speed: 500,
    arrows: false,
    fade: true,
    dots: true,
    cssEase: 'linear'
  });

  $('.slick-resources').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    cssEase: 'linear',
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    slide: '.item',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.logo-cloud .logos img').hover(
    function() {
      $('.logo-cloud').addClass('hovering');
      $(this).addClass('selected');
    },
    function() {
      $('.logo-cloud, .logo-cloud img').removeClass('hovering selected');
    }
  );

  next();
}



// WEBPACK FOOTER //
// ./src/pages/about/about.js